
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { JobWorkOrderAction } from '../../../Redux/action/JobWorkOrderAction';
import Logo from "../../../images/slogo.png";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ToastContainer, toast } from "react-toastify";
import moment from 'moment';

const JobWorkOrder = () => {
  const [jobBy, setJobBy] = useState("");
  const [projectName, setProjectName] = useState("");
  const [billedTo, setBilledTo] = useState("");
  const [jobWorkOrder, setJobWorkOrder] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [jobWorkOrderDates, setJobWorkOrderDates] = useState("");
  const [contractDates, setContractDates] = useState("");
  const [itemCount, setItemCount] = useState(1);

  const userTemplate = {
    mileStoneName: "",
    startDate: "",
    endDate: "",
    totalSprint: "",
  };

  var yea = moment(jobWorkOrderDates).format('yy');
  var mon = moment(jobWorkOrderDates).format('MM');
  var day = moment(jobWorkOrderDates).format('d');

  const jobWorkOrderDate = yea + "-" + mon + "-" + day;

  var yeas = moment(contractDates).format('yy');
  var mons = moment(contractDates).format('MM');
  var days = moment(contractDates).format('d');

  const contractDate = yeas + "-" + mons + "-" + days;

  const [users, setUsers] = useState([userTemplate]);
  console.log(users, "users data hai kya");

  const localStorageValue = users;
  if (localStorageValue[0].mileStoneName) {
    sessionStorage.setItem("usersData", JSON.stringify(localStorageValue))
  }

  let usersDatas = sessionStorage.getItem("usersData");
  console.log(JSON.parse(usersDatas), "avdesh kumarr");
  const { userResult } = useSelector((state) => state.Auth);
  let vendorId = userResult?.vendorid;
  const win = window.sessionStorage;

  const addUser = () => {
    if (itemCount == 1) {
      if (users[0].mileStoneName && users[0].startDate && users[0].endDate) {
        setUsers([...users, userTemplate]);
        setItemCount(itemCount + 1);
      } else {
        toast.error("Please Fill Value After Add Milestone!");
      }
    }
    if (itemCount == 2) {
      if (users[1].mileStoneName && users[1].startDate && users[1].endDate) {
        setUsers([...users, userTemplate]);
        setItemCount(itemCount + 1);
      } else {
        toast.error("Please Fill Value After Add Milestone!");
      }
    }
    if (itemCount == 3) {
      if (users[2].mileStoneName && users[2].startDate && users[2].endDate) {
        toast.error(`You Add only ${itemCount} Milestones!`);
      } else {
        toast.error("Please Fill Value After Add Milestone!");
      }
    }
  };

  useEffect(() => {
    if (win.getItem('jobBy'))
      setJobBy(win.getItem('jobBy'))
    if (win.getItem('projectName'))
      setProjectName(win.getItem('projectName'))
    if (win.getItem('billedTo'))
      setBilledTo(win.getItem('billedTo'))
    if (win.getItem('vendorName'))
      setVendorName(win.getItem('vendorName'))
    if (win.getItem('jobWorkOrder'))
      setJobWorkOrder(win.getItem('jobWorkOrder'))
    if (win.getItem('jobWorkOrderDate'))
      setJobWorkOrderDates(win.getItem('jobWorkOrderDate'))
    if (win.getItem('contractDate'))
      setContractDates(win.getItem('contractDate'))
    if (sessionStorage.getItem("usersData"))
      setUsers(JSON.parse(sessionStorage.getItem('usersData')))

  }, [])

  useEffect(() => {
    win.setItem("jobBy", jobBy)
    win.setItem("projectName", projectName)
    win.setItem("billedTo", billedTo)
    win.setItem("vendorName", vendorName)
    win.setItem("jobWorkOrder", jobWorkOrder)
    win.setItem("jobWorkOrderDate", jobWorkOrderDate)
    win.setItem("contractDate", contractDate)
  }, [jobBy, projectName, billedTo, vendorName, jobWorkOrder, jobWorkOrderDate, contractDate])


  const handleChange = (e, index) => {
    const updateUser = users.map((user, i) =>
      index == i
        ? Object.assign(user, { [e.target.name]: e.target.value })
        : user
    );

    console.log(updateUser, "updateUser")
    setUsers(updateUser);

  };

  const removeUser = (index) => {
    const filterData = [...users];
    filterData.splice(index, 1);
    setUsers(filterData);
  };


  let personData = sessionStorage.getItem("sprintData");
  const data = JSON.parse(personData);

  let personData1 = sessionStorage.getItem("sprintData1");
  console.log(JSON.parse(personData1), "personData1");
  let personData2 = sessionStorage.getItem("sprintData2");
  console.log(JSON.parse(personData2), "personData2");


  const content = {
    jobBy,
    vendorId,
    projectName,
    billedTo,
    vendorName,
    jobWorkOrder,
    jobWorkOrderDate,
    contractDate,
    itemCount,
    "mileStones": data
  }

  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(
      JobWorkOrderAction(content)
    );
  };
  const message = () => {
    toast.error("Please fill milestone value")
  }

  return (
    <div>
      <ToastContainer />
      <div
        className="card-header"
        style={{ background: "#f1fdff", paddingBottom: "10px" }}
      >
        <div style={{ textAlign: "center", padding: "20px" }}>

          <h2>Job Work Order</h2>
        </div>
        <div
          style={{
            width: "78%",
            background: "white",
            margin: "0 auto",
            height: "auto",
            marginBottom: "10px",
            border: "2px solid gray",
            borderRadius: "7px",
          }}
        >
          <div style={{ width: "80%", display: "flex", margin: "0 auto" }}>
            <div
              style={{
                width: "42%",
                // border: "1px solid gray",
                height: "123px",
                marginTop: "9%",
                borderRadius: "5px",
              }}
            >
              <img src={Logo} alt="" slogo />
            </div>
            <div style={{ width: "50%" }}></div>
          </div>
          <form onSubmit={handleSubmit}>
            <div
              style={{
                display: "flex",
                width: "80%",
                margin: "0 auto",
                paddingTop: "50px",
              }}
            >
              <div style={{ width: "40%" }}>
                <div className="label_job">
                  <label for="first_name">Job By</label>
                  <input
                    type="text"
                    class="form-control_Job_Form "
                    placeholder="Job By"
                    required
                    name="jobBy"
                    value={jobBy}
                    onChange={(e) => setJobBy(e.target.value)}
                  />
                </div>
                <div className="label_job">
                  <label for="first_name">Vendor Name</label>
                  <input
                    type="text"
                    class="form-control_Job_Form "
                    placeholder="vendorName"

                    name="vendorName"
                    value={vendorName}
                    onChange={(e) => setVendorName(e.target.value)}
                  />
                </div>
                <div className="label_job">
                  <label for="first_name">Project Name</label>
                  <input
                    type="text"
                    style={{ height: "29px" }}
                    class="form-control_Job_Form "
                    placeholder="Project Name"
                    required
                    name="projectName"
                    value={projectName}
                    onChange={(e) => setProjectName(e.target.value)}
                  />
                </div>
                <div className="label_job">
                  <label for="first_name">Job Work Order Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Basic example"
                      value={jobWorkOrderDate}
                      onChange={(newValue) => {
                        setJobWorkOrderDates(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </div>
              </div>
              <div style={{ width: "20%" }}></div>
              <div style={{ width: "40%" }}>
                <div className="label_job">
                  <label for="first_name">Billed To</label>
                  <input
                    type="Number"
                    class="form-control_Job_Form "
                    placeholder="Billed To"
                    required
                    name="billedTo"
                    value={billedTo}
                    onChange={(e) => setBilledTo(e.target.value)}
                  />
                </div>
                <div className="label_job">
                  <label for="first_name">Job Work Order</label>
                  <input
                    type="text"
                    style={{ height: "29px" }}
                    class="form-control_Job_Form "
                    placeholder="Job Work Order"
                    required
                    name="jobWorkOrder"
                    value={jobWorkOrder}
                    onChange={(e) => setJobWorkOrder(e.target.value)}
                  />
                </div>
                <div className="label_job">
                  <label for="first_name">Contract Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Basic example"
                      value={contractDate}
                      onChange={(newValue) => {
                        setContractDates(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
            <div className="Job_Create">
              <div
                style={{
                  border: "1px solid gray",
                  width: "92.4%",
                  margin: "0 auto;",
                  marginLeft: "52px",
                  borderRadius: "5px",
                }}
              >
                <div className="Job_button_payment">Milestone</div>
                <div>
                  <h3 style={{ textAlign: "left", marginLeft: "23px" }}>
                    Milestone
                  </h3>
                  <div>
                    <button
                      type="button"
                      style={{
                        padding: "13px 25px",
                        marginRight: "15px",
                        color: "#588fa8",
                        background: "#d6f0fd",
                        border: "1px solid #588fa8",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      onClick={addUser}
                    >
                      Add Milestone
                    </button>

                  </div>
                  {users.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        width: "95%",
                        margin: "0 auto",
                        marginTop: "45px",
                      }}
                    >
                      {/* <h3 style={{ marginRight: "10px", marginTop: "41px" }}>
                        M1
                      </h3> */}
                      <select
                        required
                        style={{
                          width: "11%",
                          height: "44px",
                          borderRadius: "5px",
                          marginLeft: "1px",
                          marginTop: "29px",
                          marginRight: "27px",
                        }}
                        className=""
                        name="mileStoneName"
                        value={item.mileStoneName}
                        onChange={(e) => handleChange(e, index)}
                      //value={userType}
                      // onChange={(e) => setUserType(e.target.value)}
                      >
                        <option className="dropdown_option">
                          Please Select Milestone
                        </option>
                        <option className="dropdown_option" value="M1">
                          M1
                        </option>
                        <option className="dropdown_option" value="M2">
                          M2
                        </option>
                        <option className="dropdown_option" value="M3">
                          M3
                        </option>
                      </select>
                      <div
                        className="picDate"
                        style={{ width: "20%", marginRight: "28px" }}
                      >
                        <label>Start Date</label>
                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
className="date-pic"
  // label="Basic example"
  value={value}
  onChange={(newValue) => {
    setValue(newValue);
  }}
  renderInput={(params) => <TextField {...params} />}
/>
</LocalizationProvider> */}

                        <input
                          style={{
                            height: "42px",
                            marginTop: "10px",
                            borderRadius: "5px",
                            border: "1px solid gray",
                          }}
                          type="text"
                          name="startDate"
                          placeholder="2022-09-09"
                          value={item.startDate}
                          onChange={(e) => handleChange(e, index)}
                        />
                      </div>
                      <div className="picDate" style={{ width: "20%" }}>
                        <label>End Date</label>
                        <input
                          style={{
                            height: "42px",
                            marginTop: "10px",
                            borderRadius: "5px",
                            border: "1px solid gray",
                          }}
                          type="text"
                          name="endDate"
                          placeholder="2022-09-19"
                          value={item.endDate}
                          onChange={(e) => handleChange(e, index)}
                        />
                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>

<DatePicker
  // label="Basic example"
 
  value={value}
  onChange={(newValue) => {
    setValue(newValue);
  }}
  renderInput={(params) => <TextField {...params} />}
/>
</LocalizationProvider> */}
                      </div>
                      <div>
                        <label>Total Sprint</label>
                        <select
                          required
                          style={{
                            width: "60%",
                            height: "44px",
                            borderRadius: "5px",
                            marginLeft: "38px",
                            marginTop: "10px",
                          }}
                          className=""
                          name="totalSprint"
                          value={item.totalSprint}
                          onChange={(e) => handleChange(e, index)}

                        //value={userType}
                        // onChange={(e) => setUserType(e.target.value)}
                        >
                          <option className="dropdown_option">
                            Total Sprint
                          </option>
                          <option className="dropdown_option" value="1">
                            1
                          </option>
                          <option className="dropdown_option" value="2">
                            2
                          </option>
                          <option className="dropdown_option" value="3">
                            3
                          </option>
                        </select>
                      </div>
                      <div style={{ marginLeft: "31px", marginTop: "29px" }}>
                        {users[0].totalSprint && users[0].mileStoneName ? (
                          <Link
                            to={`/add-sprint-detail/${users[index].mileStoneName}/${index}`}
                            state={{ id: item.totalSprint }}
                          >
                            <button
                              type="button"
                              style={{
                                width: "110%",
                                padding: "13px 13px",
                                marginRight: "15px",
                                color: "#588fa8",
                                background: "#d6f0fd",
                                border: "1px solid #588fa8",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            >
                              Add Sprint
                            </button>
                          </Link>
                        ) : (
                          <button
                            type="button"

                            style={{
                              width: "110%",
                              padding: "13px 13px",
                              marginRight: "15px",
                              color: "#d5c4c4",
                              border: "1px solid gray",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={message}
                          >
                            Add Sprint
                          </button>
                        )}
                      </div>
                      <div style={{ marginLeft: "31px", marginTop: "29px" }}>
                        <button
                          type="button"
                          style={{
                            padding: "13px 25px",
                            marginRight: "15px",
                            color: "#588fa8",
                            background: "#d6f0fd",
                            border: "1px solid #588fa8",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => removeUser(index)}
                        >
                          remove
                        </button>
                      </div>
                    </div>
                  ))}

                  <div
                    className="Job_button_payment"
                    style={{
                      marginBottom: "40px",
                      marginTop: "41px",
                      cursor: "pointer",
                    }}
                  >
                    Payment
                  </div>
                  <div
                    style={{ display: "flex", width: "95%", margin: "0 auto" }}
                  >
                    <div className="picDate" style={{ width: "20%" }}>
                      <label>Payment Type</label>
                      <select
                        required
                        style={{
                          width: "100%",
                          height: "44px",
                          borderRadius: "5px",
                          marginLeft: "0px",
                          marginTop: "10px",
                        }}
                        className=""
                        name="isCandidate"
                      // value={userType}
                      // onChange={(e) => setUserType(e.target.value)}
                      >
                        <option className="dropdown_option">Total</option>
                        <option className="dropdown_option" value="1">
                          1
                        </option>
                        <option className="dropdown_option" value="2">
                          2
                        </option>
                        <option className="dropdown_option" value="3">
                          3
                        </option>
                      </select>
                    </div>
                    <div className="picDate" style={{ width: "20%" }}>
                      <label>Payment %</label>
                      <input
                        type="text"
                        style={{
                          width: "100px",
                          height: "35px",
                          marginTop: "12px",
                        }}
                      />
                    </div>
                    <div>
                      <label>Currency</label>
                      <select
                        required
                        style={{
                          width: "137%",
                          height: "44px",
                          borderRadius: "5px",
                          marginLeft: "3px",
                          marginTop: "10px",
                        }}
                        className=""
                        name="isCandidate"
                      // value={userType}
                      // onChange={(e) => setUserType(e.target.value)}
                      >
                        <option className="dropdown_option">$</option>
                        <option className="dropdown_option" value="CANDIDATE">
                          1
                        </option>
                        <option className="dropdown_option" value="VENDOR">
                          2
                        </option>
                        <option className="dropdown_option" value="VENDOR">
                          3
                        </option>
                      </select>
                    </div>
                    <div style={{ marginLeft: "50px" }}>
                      <label>Amount</label>
                      <input
                        type="text"
                        style={{
                          width: "100px",
                          height: "37px",
                          marginTop: "11px",
                        }}
                      />
                    </div>
                    <div style={{ marginLeft: "-21px" }}>
                      <label>Extra Amount</label>
                      <input
                        type="text"
                        style={{
                          width: "100px",
                          height: "37px",
                          marginTop: "11px",
                        }}
                      />
                    </div>
                    <div style={{ marginLeft: "-12px" }}>
                      <label>Total</label>
                      <input
                        type="text"
                        style={{
                          width: "100px",
                          height: "37px",
                          marginTop: "11px",
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "30px", marginBottom: "30px" }}>
                    <button
                      style={{
                        padding: "10px 30px",
                        color: "#588fa8",
                        background: "#d6f0fd",
                        border: "1px solid #588fa8",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Add another payment
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <button
                style={{
                  padding: "13px 25px",
                  marginRight: "15px",
                  color: "#588fa8",
                  background: "transparent",
                  border: "1px solid #588fa8",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Preview
              </button>
              <button type="submit"
                style={{
                  padding: "13px 25px",
                  marginRight: "15px",
                  color: "#588fa8",
                  background: "#d6f0fd",
                  border: "1px solid #588fa8",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default JobWorkOrder;
